var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductDraw = function SvgProductDraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 20.6 50.5 14l7.1 38.8-35.8 6.6-7.1-38.8Z",
    fill: "#116DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 18.7 58.5 23l-4.8 39.2-36.2-4.4 4.8-39.1Z",
    fill: "#28BF9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11h39v45H19V11Z",
    fill: "#D6E6FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17h27v31H25V17Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m25 48 10.9-11.3 6.3 6.2 4.6-5.2L52 43v5H25Z",
    fill: "#CFE5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8 42.1 35 20l13.2 17.9-5.6.9 4.1 7.2-3.6 2-4.3-5.9Z",
    fill: "#FFC0B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m55.4 6.3-1.8 11.1m10.2-2.3-8.4 7M45.8 5.8l1.1 9.5",
    stroke: "#000624",
    strokeWidth: 1.3
  })));
};
export default SvgProductDraw;